"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _text_input = require("../../text_input");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var VelocityFrequentFlyerInput = function VelocityFrequentFlyerInput(_ref) {
  var register = _ref.register;
  return /*#__PURE__*/_react["default"].createElement(_text_input.TextInput, {
    type: "text",
    name: "velocityNumber",
    label: "Velocity Frequent Flyer Number",
    register: register
  });
};
VelocityFrequentFlyerInput.propTypes = {
  register: _propTypes["default"].func
};
VelocityFrequentFlyerInput.defaultProps = {
  register: function register() {}
};
var _default = exports["default"] = VelocityFrequentFlyerInput;